module.exports = __webpack_public_path__ + "img/sharedMedias.8c5f2a3c.svg";